import React from 'react';
import styled from 'styled-components';
import { colors } from '../styles/GlobalStyles';
import { rv, containerWidth } from '../styles/responsive';

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const Overlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 999;
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: ${containerWidth(700, 24)};
  max-height: 85vh;
  background: ${colors.white};
  border-radius: ${rv(24, 20)};
  overflow: hidden;
  z-index: 1000;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  padding: ${rv(24, 20)} ${rv(32, 24)};
  border-bottom: 1px solid ${colors.slate[100]};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalTitle = styled.h2`
  font-size: ${rv(20, 16)};
  font-weight: 700;
  color: ${colors.slate[900]};
`;

const CloseButton = styled.button`
  background: ${colors.slate[100]};
  color: ${colors.slate[600]};
  border: none;
  width: ${rv(32, 32)};
  height: ${rv(32, 32)};
  border-radius: ${rv(8, 8)};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${rv(20, 18)};
  transition: all 0.2s ease;

  &:hover {
    background: ${colors.slate[200]};
    color: ${colors.slate[900]};
  }
`;

const ModalContent = styled.div`
  padding: ${rv(32, 24)};
  overflow-y: auto;
  flex: 1;
`;

const Paragraph = styled.p`
  line-height: 1.8;
  font-size: ${rv(14, 12)};
  color: ${colors.slate[600]};
  white-space: pre-line;
`;

const TermsModal: React.FC<TermsModalProps> = ({ isOpen, onClose }) => {
  const content = `[ 이용약관 ]

제1조 (목적)
본 약관은 NeuralNetwork(이하 "회사")가 운영하는 웹사이트(이하 "사이트")에서 제공하는 서비스의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.

제2조 (정의)
1. "사이트"란 회사가 서비스를 제공하기 위해 운영하는 웹사이트(현 웹 사이트)를 의미합니다.
2. "이용자"란 본 사이트에 접속하여 회사가 제공하는 정보를 열람하거나 문의, 외주 의뢰 등 행위를 하는 자를 말합니다.
3. "서비스"란 회사가 운영하는 웹사이트를 통해 제공하는 웹 개발, 앱 개발, AI 솔루션, 외주 개발 상담, 포트폴리오 열람 등 관련 정보 일체를 의미합니다.

제3조 (약관의 효력 및 변경)
1. 본 약관은 사이트에 게시함으로써 효력을 발생하며, 이용자가 본 사이트에 방문하거나 서비스를 이용하는 경우 본 약관에 동의한 것으로 간주됩니다.
2. 회사는 필요하다고 판단되는 경우 관련 법령을 위반하지 않는 범위 내에서 본 약관을 변경할 수 있으며, 변경된 약관은 사이트에 공지함으로써 효력을 발생합니다.
3. 이용자는 정기적으로 본 약관의 변경사항을 확인할 의무가 있으며, 변경 이후에도 서비스를 이용하는 경우 변경된 약관에 동의한 것으로 간주합니다.

제4조 (서비스의 제공 및 변경)
1. 회사는 웹/앱/AI 개발 및 외주 관련 정보, 포트폴리오, 기술 블로그, 프로젝트 소개 등 다양한 서비스를 제공합니다.
2. 회사는 기술적 필요나 운영상의 사정으로 사전 공지 없이 서비스를 수정, 변경, 중단할 수 있습니다.
3. 회사는 서비스 내용의 변경, 중단으로 인해 발생하는 문제에 대해 법적 책임을 지지 않습니다.

제5조 (이용자의 의무)
1. 이용자는 본 사이트를 건전한 목적과 방식으로 이용하여야 하며, 다음 각 호의 행위를 해서는 안 됩니다.
  1) 회사 또는 제3자의 저작권, 상표권 등 지적재산권을 침해하는 행위
  2) 타인의 명의를 도용하거나 허위 정보를 입력하는 행위
  3) 컴퓨터 바이러스, 악성 코드 등을 포함한 자료를 게시 또는 전송하는 행위
  4) 사이트 운영을 방해하거나 고의적으로 과부하를 유발하는 행위
  5) 기타 관련 법령 및 공서양속에 반하는 행위
2. 이용자는 본 약관 및 회사가 공지하는 사항을 준수해야 하며, 회사의 정상적인 운영을 방해하는 행위에 대해 민·형사상의 책임을 질 수 있습니다.

제6조 (저작권)
1. 회사가 사이트를 통해 제공하는 콘텐츠(텍스트, 이미지, 코드, 영상, 기술자료 등)의 저작권은 회사에 있으며, 이용자는 회사의 사전 서면 동의 없이 이를 무단 복제, 배포, 전송, 수정, 전시하거나 상업적으로 이용할 수 없습니다.
2. 이용자가 게시한 자료의 저작권은 해당 이용자에게 있으며, 회사는 서비스를 운영하기 위한 범위 내에서 해당 자료를 사용할 수 있습니다.

제7조 (면책조항)
1. 회사는 이용자가 사이트에서 제공하는 정보를 바탕으로 의사결정을 하거나 외주를 의뢰한 결과에 대해서 직접적인 책임을 지지 않습니다.
2. 회사는 이용자 간 또는 이용자와 제3자 간에 발생한 분쟁에 대해 개입하지 않으며, 그에 따른 손해에 대해서도 책임을 지지 않습니다.
3. 회사는 천재지변, 서버 장애, 네트워크 장애 등 불가항력적인 사유로 인해 발생한 서비스 이용 장애에 대해 책임을 지지 않습니다.

제8조 (개인정보 보호)
1. 회사는 현재 개인정보를 수집하지 않으며, 회원가입, 로그인, 결제 등의 기능도 제공하지 않습니다.
2. 다만, 추후 이용자가 이메일, 문의 폼 등을 통해 직접 제공한 개인정보가 발생할 경우, 이에 대한 별도의 개인정보처리방침을 통해 고지하고 관리할 예정입니다.

제9조 (약관의 해석 및 관할)
1. 본 약관은 대한민국 법률에 따라 해석됩니다.
2. 서비스 이용과 관련하여 회사와 이용자 간 발생한 분쟁에 대해서는 회사의 주소지를 관할하는 법원을 제1심의 전속 관할 법원으로 합니다.

본 약관은 2025년 4월 17일부터 적용됩니다.`;

  if (!isOpen) return null;

  return (
    <Overlay $isOpen={isOpen} onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>이용약관</ModalTitle>
          <CloseButton onClick={onClose}>&times;</CloseButton>
        </ModalHeader>
        <ModalContent>
          <Paragraph>{content}</Paragraph>
        </ModalContent>
      </ModalContainer>
    </Overlay>
  );
};

export default TermsModal;
